/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import bentoMLLogo from '@/assets/bentoml/bentoml.png'
import avevaLogo from '@/assets/aveva/Aveva_logo.svg'
import ignitionLogo from '@/assets/ignition/ignition-logo.svg'

function MachineLearningTopNode({ data, isConnectable }) {
  const mlLogo = () => {
    const demoEnv = localStorage.getItem('TARGET')
    if (demoEnv === 'MSFT') {
      return bentoMLLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'AWS') {
      return bentoMLLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'GCP') {
      return bentoMLLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return bentoMLLogo
    }
  }
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={mlLogo()} alt="Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>Machine Learning at Edge</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Top} />
      <Handle type="source" position={Position.Top} />
    </div>
  )
}

export default MachineLearningTopNode
